import script from "./esManagePersonFinancialGroup.vue?vue&type=script&setup=true&lang=ts"
export * from "./esManagePersonFinancialGroup.vue?vue&type=script&setup=true&lang=ts"

import "./esManagePersonFinancialGroup.vue?vue&type=style&index=0&id=90cfeb7a&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-90cfeb7a"]])

export default __exports__